var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useMemo } from 'react';
import { Form as AntdForm } from 'antd';
import { InternalForm } from '@formily/react-schema-renderer';
import { normalizeCol, autoScrollInValidateFailed, isAntdV4, log, cloneChlildren } from '../shared';
import { FormItemDeepProvider } from '../context';
import { PreviewText } from '@formily/react-shared-components';
import { isFn } from '@formily/shared';
export var Form = function (props) {
    var inline = props.inline, effects = props.effects, actions = props.actions, initialValues = props.initialValues, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, onSubmit = props.onSubmit, form = props.form, useDirty = props.useDirty, onValidateFailed = props.onValidateFailed, previewPlaceholder = props.previewPlaceholder, editable = props.editable, validateFirst = props.validateFirst, children = props.children, rest = __rest(props, ["inline", "effects", "actions", "initialValues", "value", "defaultValue", "onChange", "onSubmit", "form", "useDirty", "onValidateFailed", "previewPlaceholder", "editable", "validateFirst", "children"]);
    var formRef = useRef();
    return (React.createElement(InternalForm, __assign({}, props, { onValidateFailed: function (result) {
            if (props.onValidateFailed) {
                props.onValidateFailed(result);
            }
            autoScrollInValidateFailed(formRef);
        } }), function (form) {
        var onSubmit = function (e) {
            if (e && e.preventDefault)
                e.preventDefault();
            if (e && e.stopPropagation)
                e.stopPropagation();
            form.submit().catch(function (e) { return log.warn(e); });
        };
        var onReset = function () {
            form.reset({ validate: false, forceClear: false });
        };
        var renderedChildren = isFn(children)
            ? children(form)
            : cloneChlildren(children);
        return (React.createElement(PreviewText.ConfigProvider, { value: props },
            React.createElement(FormItemDeepProvider, __assign({}, props),
                React.createElement("div", { ref: formRef },
                    React.createElement(AntdForm, __assign({}, rest, { component: useMemo(function () {
                            if (isAntdV4) {
                                return function (props) {
                                    return React.createElement('form', __assign(__assign({}, props), { onSubmit: onSubmit,
                                        onReset: onReset }));
                                };
                            }
                        }, []), onSubmit: onSubmit, onReset: onReset, labelCol: normalizeCol(props.labelCol), wrapperCol: normalizeCol(props.wrapperCol), layout: inline ? 'inline' : props.layout }), renderedChildren)))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/components/Form.js
// module id = 5804
// module chunks = 0